import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom';

const CTAPatientExp = ({ items }) => {
    const navigate = useNavigate();

    return (
        <Fragment>
            {/* first CTA section */}
            <div className="mx-auto max-w-7xl px-3 py-6 sm:px-3 lg:px-6">
                <div className={`rounded-2xl border border-slate-200 shadow-sm`} style={{backgroundColor:"rgb(239 246 255 / 0.5)"}}>
                    <div className="flex flex-col divide-y divide-slate-200 md:flex-row md:divide-x md:divide-y-0">
                        {items.map((item, index) => (
                            <div key={item.id || index} className="group flex flex-1 cursor-pointer items-center  gap-2 p-4 transition-colors duration-150 hover:bg-blue-50/50 md:flex-col lg:flex-row">
                                
                                {/* Content */}
                                <div className="min-w-0 flex-1 flex flex-row gap-4 sm:gap-0 items-start md:flex-col md:justify-center items-center text-center">
                                    <div className="flex h-12 w-12 primary-bg shrink-0 items-center justify-center rounded-full mb-2">
                                        <img
                                            src={item.image}
                                            alt={item.heading}
                                            className="h-5 w-5 object-contain"
                                        />
                                    </div>
                                    <p className="mb-1 font-semibold text-sm sm:text-s lg:text-[18px] primary-text">
                                        {item.heading}
                                    </p>
                                    <p className="text-[10px] sm:text-xs lg:text-sm leading-relaxed primary-text">
                                        {item.description}
                                    </p>
                                    {item.description2 && (
                                        <p className="text-[10px] sm:text-xs lg:text-sm leading-relaxed primary-text">
                                            {item.description2}
                                        </p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* second CTA section */}
            <section className="w-full px-4 sm:px-6 pb-8 pt-8 max-w-7xl mx-auto">
                <div className="relative flex flex-col sm:flex-row items-center justify-between gap-5 rounded-2xl overflow-hidden px-6 sm:px-8 py-7 sm:py-8" style={{ backgroundColor: 'var(--primary-color)', border: '0.5px solid #c8d8ec' }}>
                    <div className="flex flex-col gap-1 w-full lg:w-2/5 text-center sm:text-left">
                        <h3
                            className="font-semibold leading-snug"
                            style={{ fontSize: 'clamp(0.95rem, 2vw, 1.15rem)', color: 'white' }}
                        >
                            Care that feels personal. Because it is.
                        </h3>
                        <p
                            className="leading-relaxed"
                            style={{ fontSize: 'clamp(0.78rem, 1.2vw, 0.875rem)', color: 'white', maxWidth: '360px' }}
                        >
                            Experience women's healthcare the way it should be.
                        </p>
                    </div>
                    {/* Button */}
                    <div className="flex flex-col flex-wrap sm:flex-row gap-3 sm:gap-4 items-center justify-center  w-full lg:w-3/5">
                        <button
                            onClick={() => navigate('/carejourney')}
                            className="btn-outline flex items-center gap-2 rounded-md font-semibold bg-white "
                            style={{
                                fontSize: 'clamp(0.7rem, 1.2vw, 0.9rem)',
                                padding: 'clamp(0.4rem, 0.8vw, 0.65rem) clamp(0.9rem, 2vw, 1.6rem)',
                                color: "var(--primary-color)"
                            }}
                        >
                            Start Your Journey
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        <button
                            onClick={() => navigate('/book-appointment')}
                            className="btn-outline flex items-center gap-2 rounded-md font-semibold hover:bg-[var(--primary-color)]"
                            style={{
                                fontSize: 'clamp(0.7rem, 1.2vw, 0.9rem)',
                                padding: 'clamp(0.4rem, 0.8vw, 0.65rem) clamp(0.9rem, 2vw, 1.6rem)',
                                color: "white"
                            }}
                        >
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                    d="M8 7V3m8 4V3m-9 8h10m-12 9h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2z" />
                            </svg>
                            Book An Appointment

                        </button>
                        <button
                            onClick={() => navigate('/carejourney')}
                            className="btn-outline flex items-center gap-2 rounded-md font-semibold hover:bg-[var(--primary-color)]"
                            style={{
                                fontSize: 'clamp(0.7rem, 1.2vw, 0.9rem)',
                                padding: 'clamp(0.4rem, 0.8vw, 0.65rem) clamp(0.9rem, 2vw, 1.6rem)',
                                color: "white"
                            }}
                        >
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                    d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m10-4.13a4 4 0 10-8 0 4 4 0 008 0z" />
                            </svg>
                            Talk to a Care Navigator
                        </button>
                    </div>
                </div>
            </section>

        </Fragment>
    )
}

export default CTAPatientExp